/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import _sortBy from 'lodash.sortby';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import SqlImportModel from 'cio/models/sql-import';
import SqlImportRowFragment from 'cio/models/sql-import-row';
import ApiService from 'cio/services/api';
import { task } from 'ember-concurrency';

interface SqlImportsImportRowsArgs {
  model: SqlImportModel;
}

export default class SqlImportsImportRows extends Component<SqlImportsImportRowsArgs> {
  @service api!: ApiService;

  @tracked expandedRow: SqlImportRowFragment | null = null;

  @action
  expand(row: SqlImportRowFragment) {
    if (this.expandedRow === row) {
      this.expandedRow = null;
    } else {
      this.expandedRow = row;
    }
  }

  get blankSlateTitle() {
    return `Sync ${this.args.model.syncTarget.toLowerCase()} from your database`;
  }

  @computed('args.model.imports.@each.createdAt')
  get importRows() {
    return _sortBy(this.args.model.imports, ['createdAt']).reverse();
  }

  cancelImport = task(async () => {
    await this.expandedRow?.cancel({});
    await this.args.model.hasMany('sqlImportRows').reload();
  });
}
